import { useCallback } from 'react';
import { getV4LinkFromIntegrations } from '../../routing/redirectToV4';
import { useOpenInBrowserMutation } from '../gql';

export const useOpenLinkInBrowserFromUxp = () => {
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });

  const openLinkInBrowserFromUxp = useCallback(
    (href: string) => {
      openInBrowser({
        variables: { input: { url: getV4LinkFromIntegrations(href) } },
      });
    },
    [openInBrowser]
  );

  return openLinkInBrowserFromUxp;
};
